var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8577 20.8579L35.1651 35.1654",
    stroke: "#004057",
    strokeWidth: 3.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8577 35.1653L35.1651 20.8578",
    stroke: "#004057",
    strokeWidth: 3.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9641 10.1219C35.2518 10.1221 35.5278 10.2365 35.7312 10.44L45.5661 20.2827C45.7695 20.4862 45.8837 20.7622 45.8836 21.05L45.8782 34.9641C45.8781 35.2519 45.7637 35.5278 45.5601 35.7312L35.7175 45.5662C35.5139 45.7696 35.2379 45.8838 34.9502 45.8837L21.036 45.8783C20.7483 45.8782 20.4723 45.7637 20.2689 45.5602L10.434 35.7176C10.2306 35.514 10.1164 35.238 10.1165 34.9502L10.1219 21.0361C10.122 20.7483 10.2364 20.4724 10.44 20.269L20.2826 10.434C20.4862 10.2306 20.7622 10.1164 21.0499 10.1165L34.9641 10.1219Z",
    stroke: "#004057",
    strokeWidth: 3.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.39ef2dff1cb62719ad31cb1fea45fa5f.svg";
export { ForwardRef as ReactComponent };